import React, { useState } from 'react';
import { Alert, Button, Modal, Select, Space, Typography, message } from 'antd';
import { EyeOutlined, RollbackOutlined } from '@ant-design/icons';
import api, { currentUser, endPreview, inPreview, startPreview } from '../utils/api';
import { isAdmin } from '../utils/roles';

const errMsg = (e) => e?.response?.data?.detail || 'Could not switch the view';

/** Admin only: open the system as a user or role sees it (read-only). */
export const ViewAsButton = () => {
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState(null);
  const [pick, setPick] = useState();
  const [busy, setBusy] = useState(false);
  if (!isAdmin() || inPreview()) return null;

  const show = async () => {
    setOpen(true);
    if (!opts) {
      try {
        setOpts((await api.get('/auth/view-as/')).data);
      } catch (e) {
        message.error(errMsg(e));
      }
    }
  };
  const go = async () => {
    if (!pick) return;
    setBusy(true);
    try {
      const [kind, value] = pick.split(':');
      const r = await api.post('/auth/view-as/', kind === 'user' ? { user: Number(value) } : { role: value });
      startPreview(r.data);
      window.location.href = '/';
    } catch (e) {
      message.error(errMsg(e));
      setBusy(false);
    }
  };
  const options = opts ? [
    { label: 'People', options: opts.users.map((u) => ({ value: `user:${u.id}`, label: `${u.name} (${u.username}) - ${u.label}` })) },
    { label: 'Roles', options: opts.roles.map((r) => ({ value: `role:${r.code}`, label: `Any ${r.label}` })) },
  ] : [];

  return (
    <>
      <Button size="small" icon={<EyeOutlined />} onClick={show}>View as</Button>
      <Modal title="View the system as" open={open} onCancel={() => setOpen(false)} onOk={go}
        okText="Open" okButtonProps={{ disabled: !pick, loading: busy }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Typography.Text type="secondary">
            You see the menu, screens and figures exactly as that person or role does. Nothing can be saved while
            viewing; use "Back to {currentUser()?.first_name || currentUser()?.username}" to return.
          </Typography.Text>
          <Select showSearch style={{ width: '100%' }} placeholder="Choose a person or a role" loading={!opts}
            options={options} value={pick} onChange={setPick} optionFilterProp="label" />
        </Space>
      </Modal>
    </>
  );
};

/** Banner shown on every screen while the Admin is viewing as someone else. */
export const ViewAsBanner = () => {
  if (!inPreview()) return null;
  const p = currentUser()?.preview || {};
  const back = () => {
    endPreview();
    window.location.href = '/';
  };
  return (
    <Alert type="warning" showIcon banner className="view-as-banner"
      message={<span>Viewing as <b>{p.name}</b> ({p.label}) - read only. Saving is switched off.</span>}
      action={<Button size="small" type="primary" icon={<RollbackOutlined />} onClick={back}>Back to {p.admin || 'my account'}</Button>} />
  );
};
